const API_BASE_URL = "https://travely-43dfb076364f.herokuapp.com/api";

export default API_BASE_URL;
